















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsFormComponentsLeveler extends Vue {
  @Prop({type: Number, required: true})
  value: number;

  @Prop({type: Array, required: true})
  scale: Array<number>;

  @Prop({type: Boolean, default: false})
  error: boolean;

  levelValue: number = this.value;

  @Watch('value')
  changeLavel(value: number) {
    this.levelValue = value;
  }

  setLevel(value: number) {
    const { scale } = this;
    if (value == 0 && this.levelValue !== scale[0]) {
      this.levelValue--;
      this.$emit('input', this.levelValue);
    }
    if (value == 1 && this.levelValue < scale.length) {
      this.levelValue++;
      this.$emit('input', this.levelValue);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/formrange/components/Leveler.vue